import React from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import ValueProps from "@/components/landing/ValueProps";
import AppPreview from "@/components/landing/AppPreview";
import CouplePoses from "@/components/landing/CouplePoses";
import SetTest from "@/components/landing/SetTest";
import TrainingFilters from "@/components/landing/TrainingFilters";
import MatchWindow from "@/components/landing/MatchWindow";
import Safety from "@/components/landing/Safety";
import Playlist from "@/components/landing/Playlist";
import Community from "@/components/landing/Community";
import MidCTA from "@/components/landing/MidCTA";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";

const Landing = () => {
  return (
    <main data-testid="landing-page" className="bg-[#0A0A0A] text-white overflow-x-hidden">
      <Navbar />
      <Hero />
      <ValueProps />
      <AppPreview />
      <CouplePoses />
      <SetTest />
      <TrainingFilters />
      <MatchWindow />
      <Safety />
      <Playlist />
      <Community />
      <MidCTA />
      <FAQ />
      <FinalCTA />
      <Footer />
    </main>
  );
};

export default Landing;
